import { Font } from '@react-pdf/renderer';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import publicSansBold from 'src/assets/fonts/PublicSans-Bold.ttf';
import publicSansItalic from 'src/assets/fonts/PublicSans-Italic.ttf';
import publicSansRegular from 'src/assets/fonts/PublicSans-Regular.ttf';

import { AuthProvider } from './auth';
import { Snackbar } from './components/snackbar';
import { useScrollToTop } from './hooks/useScrollToTop';
import { useDynatraceLoader } from './hooks/useDynatrace';
import { HistoryProvider } from './routes/context/HistoryContext';

// ------------------------ PDF Configs --------------------------------
Font.register({
  family: 'Public Sans',
  fonts: [
    { src: publicSansRegular },
    { src: publicSansBold, fontWeight: 700 },
    { src: publicSansItalic, fontStyle: 'italic' },
  ],
});

// ------------------------ Tanstack Query Client --------------------------------
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60,
    },
  },
});

function App({ children }: { children: React.ReactNode }) {
  useScrollToTop();
  useDynatraceLoader();

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Snackbar />
        <HistoryProvider>{children}</HistoryProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
